import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="container">
        <button onClick={() => navigate('/')} className="back-button">
          <ArrowLeft size={20} />
          <span>Назад</span>
        </button>
        
        <div className="legal-content">
          <h1 className="heading-1">{t.privacyPage.title}</h1>
          <p className="body-large">{t.privacyPage.content}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;